import { render, staticRenderFns } from "./Troubadour.vue?vue&type=template&id=68a7cf90&"
import script from "./Troubadour.vue?vue&type=script&lang=js&"
export * from "./Troubadour.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports